<template>
  <section class="content">
    <div id="overlay" v-if="loading">
      <div class="spinner"></div>
      <br/>
      <h4>Loading...</h4>
    </div>
    <div>
      <div class="box box-info">
        <!-- <Toast style="margin-top: 35px" /> -->
        <form>
          <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-2">
              <label for="fromDate">From Date</label>
              <date-picker v-model="fromDate" valueType="format" v-if="!englishDateEnabled"/>
              <InputMask mask="9999-99-99" type="text" v-else class="nepali-calendar" id="fromDate" v-model="fromDate"/>
            </div>

            <div class="p-field p-col-12 p-md-2">
              <label for="toDate">To Date</label>
              <date-picker v-model="toDate" valueType="format" v-if="!englishDateEnabled"/>
              <InputMask mask="9999-99-99" type="text" v-else class="nepali-calendar" id="toDate" v-model="toDate"/>
            </div>
            <!-- <label for="voucher" class="col-sm-1 control-label">Voucher</label> -->
            <!-- <div class="p-field p-col-12 p-md-1 p-mt-5">
               <Button type="submit"  @click.prevent="searchOrderCompletedReport"
               class="p-button-raised" label="Search" icon="pi pi-search"/>
            </div> -->
            <div class="p-field p-col-12 p-md-1 p-mt-5">
              <Button icon="pi pi-search" @click.prevent="searchOrderCompletedReport"
                      class="p-button-raised" label="Search"/>
            </div>
          </div>
          <Dialogs header="Reason" :visible.sync="ecommerceStatusDialog"
                   :style="{width: '50vw'}" :modal="true" :closable=false :contentStyle="{'overflow': 'visible'}">
            <div class="col-md-12">
              <label for="reason" class="col-md-4 control-label">Reason</label>
              <div class="form-group col-md-8">
                <textarea class="form-control" rows="5" v-model="reason"></textarea>
              </div>
            </div>
            <template #footer>
              <Button class="p-button-raised p-button-success" @click.prevent="updateOrderStatus"
                      label="Send"/>
              <Button class="p-button-raised p-button-danger" @click.prevent="cancel" label="Cancel"/>
            </template>
          </Dialogs>
        </form>
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-col-12">
            <a href="#" @click.prevent="exportCSV()" v-if="this.salesOrderCompletedList.length > 0 && this.$store.getters.modules.includes('5.38')">
              <img src="../../../../static/img/excel.png" style="margin-left: 90em;height: 3em;width: 3em;"/>
            </a>
            <DataTable :value="salesOrderCompletedLists" dataKey="id" ref="dt"
                       :paginator="true" editMode="cell"
                       :rowsPerPageOptions="[100,500,1000]"
                       :rows="100" :filters="filters"
                       class="p-datatable-gridlines editable-cells-table"
                       :selection.sync="selectedProduct1" selectionMode="single">
              <!-- <Column selectionMode="multiple" headerStyle="width: 3rem"></Column> -->
              <Column header="S.N">
                <template #body="sl">
                  {{sl.index+1}}
                </template>
              </Column>
                <Column header="Miti" headerStyle="width:8em;" :sortable="true" field="purchaseSalesDateNepali"
                        filterMatchMode="contains">
                  <template #filter>
                    <InputText type="text" class="p-column-filter" v-model="filters['purchaseSalesDateNepali']"/>
                  </template>
                </Column>
                <Column header="Date" headerStyle="width:8em;" :sortable="true" field="purchaseSalesDate"
                        filterMatchMode="contains">
                  <template #filter>
                    <InputText type="text" class="p-column-filter" v-model="filters['purchaseSalesDate']"/>
                  </template>
                </Column>
                <Column header="Order No" :sortable="true" field="orderNo" filterMatchMode="contains">
                  <template #filter>
                    <InputText type="text" class="p-column-filter" v-model="filters['orderNo']"/>
                  </template>
                </Column>
                <Column header="Customer" :sortable="true" field="accountName" filterMatchMode="contains">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['accountName']"/>
              </template>
              <template #footer>
                  Total:
                </template>
            </Column>
            <Column header="Address" :sortable="true" field="address" filterMatchMode="contains">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['address']"/>
              </template>
            </Column>
                <Column header="Store" :sortable="true" field="warehouse.name" filterMatchMode="contains">
                  <template #filter>
                    <InputText type="text" class="p-column-filter" v-model="filters['warehouse.name']"/>
                  </template>
                </Column>
                <Column header="Total" bodyStyle="text-align: right" :sortable="true" field="totalBillAmount"
                        filterMatchMode="contains">
                  <template #filter>
                    <InputText type="text" class="p-column-filter" v-model="filters['totalBillAmount']"/>
                  </template>
                </Column>
                <!-- <Column :sortable="true"
            header="Status"
            field="ecommerceStatus"
            filterMatchMode="contains"
          >
          <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['ecommerceStatus']" />
          </template>
          </Column> -->

                <!-- <Column header="Ship Date" :sortable="true" field="shipDate" filterMatchMode="contains">
                  <template #filter>
                    <InputText type="text" class="p-column-filter" v-model="filters['shipDate']"/>
                  </template>
                </Column> -->
                <!-- <Column field="ecommerceStatus" header="Status" filterMatchMode="contains">
                  <template #editor="slotProps">
                      <Dropdown v-model="slotProps.data['ecommerceStatus']" :options="statuses" @change="showReasonDialog(slotProps.data)"
                       optionLabel="label" optionValue="value" placeholder="Select a Status" :disabled="slotProps.data['ecommerceStatus']==='Completed'?true:false">
                          <template #option="slotProps">
                              <span  :class="'product-badge status-' + slotProps.option.value.toLowerCase()">{{slotProps.option.label}}</span>
                          </template>
                      </Dropdown>
                  </template>
                  <template #body="slotProps">
                      {{getStatusLabel(slotProps.data.ecommerceStatus)}}
                  </template>
              </Column> -->
                <!-- <Column header="Action" >
                <template #body="slotProps"> -->
                <!-- <Button  class="btn btn-success pull-right" style="margin-left:5px" >
                   <i class="fa fa-edit" @click="editSalesOrder(slotProps.data)" />
                  </Button> -->
                <!-- <Button class="p-button-raised p-button-danger"
                @click="openDialog(slotProps.data.id)" icon="pi pi-trash"/>
                <Button class="p-button-raised p-button-danger" @click="viewPIVDetail(slotProps.data)"/>

                <Button class="p-button-raised p-button-warning" @click="exportToPdf(slotProps.data.id)" icon="pi pi-print"/>
            </template>
          </Column> -->

                <Column header="Action" headerStyle="width:14em;">
                  <template #body="slotProps">
                    <!-- Edit Button -->
                    <!-- <Button icon="pi pi-pencil" v-if="enableEdit" class="p-button-raised p-button-success" @click="editSalesOrder(slotProps.data)" />
                    <Button icon="pi pi-pencil" v-else disabled class="p-button-raised p-button-success" @click="editSalesOrder(slotProps.data)"/> -->
                    <!-- Edit button -->
                    <!-- DeleteButton -->
                    <!-- <Button v-if="enableDelete" class="p-button-raised p-button-danger"
                      @click="openDialog(slotProps.data.id)" icon="pi pi-trash"/>
                      <Button v-else disabled class="p-button-raised p-button-danger"
                      @click="openDialog(slotProps.data.id)" icon="pi pi-trash"/> -->
                    <!-- Delete Button -->
                    <Button class="p-button-raised" @click="viewPIVDetail(slotProps.data)"  v-tooltip.top="'View Details'"
                            icon="pi pi-eye"/>
                    <Button class="p-button-raised p-button-secondary"  v-tooltip.top="'Print'"
                            @click="exportToPdf(slotProps.data.id)"
                            icon="pi pi-print"/>
                  </template>
                </Column>
            </DataTable>
          </div>
        </div>
      </div>
    </div>
    <Dialog v-model="dialogShow" @cancel="cancel" @deleted="deleteReport"/>
  </section>
</template>
<script>
import DatePicker from 'vue2-datepicker'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Dialog from '../../layout/dialog'
import globalKey from '../../../store/globalKey'
import axios from 'axios'
import $ from 'jquery'
import InputText from 'primevue/inputtext'
// import Toast from 'primevue/toast'
import InputMask from 'primevue/inputmask'
import Dropdown from 'primevue/dropdown'
import Dialogs from 'primevue/dialog'
import Checkbox from 'primevue/checkbox'
import Button from 'primevue/button'

export default {
  name: 'salesOrderReport',
  data() {
    return {
      fromDate: null,
      toDate: null,
      salesOrderCompletedList: [],
      loading: false,
      dialogShow: false,
      columnList: '',
      filters: {},
      englishDateEnabled: true,
      selectedProduct1: null,
      idsForOrderPrint: [],
      selectedSalesOrderId: null,
      ecommerceStatusDialog: false,
      reason: '',
      ecommerceStatusData: '',
      inventoryHeaderId: null,
      // [{label: 'In Stock', value: 'INSTOCK'},{label: 'Low Stock', value: 'LOWSTOCK'},{label: 'Out of Stock', value: 'OUTOFSTOCK'}]
      statuses: [{label: 'Processing', value: 'Processing'}, {label: 'Hold', value: 'Hold'}, {
        label: 'Completed',
        value: 'Completed'
      }, {label: 'Cancel', value: 'Cancelled'}]
    }
  },
  mounted() {
    this.checkEnglish()
    if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
      this.nepaliDate()
    }
    if (!this.$store.getters.englishDate && this.salesChallan === undefined ||
      this.$store.state.isEnglishDateEnabled === 'false') {
      this.setNepaliDate()
    }
    if (this.$store.state.isEnglishDateEnabled && this.$store.state.isEnglishDateEnabled !== 'false') {
      this.setEnglishDate()
    }
    this.columnNames()
  },
  computed: {
    salesOrderCompletedLists() {
      return this.$store.state.sales.salesOrderCompletedLists
    }
  },
  methods: {
    async searchOrderCompletedReport() {
      let dat = {
        fromDate: this.fromDate,
        toDate: this.toDate
      }
      this.loading = !this.loading
      let resp = await this.$store.dispatch('loadSalesOrderCompletedLists', dat)
      this.loading = false
      if (resp.data.data.length <= 0) {
        this.$toast.add({severity: 'error', summary: '', detail: resp.data.message, life: 10000})
        this.salesOrderCompletedList = []
      } else {
        this.salesOrderCompletedList = resp.data.data
      }
    },
    async viewPIVDetail(data) {
      let PIHdata = {
        id: data.id,
        warehouse: data.warehouse,
        account: data.accountMaster,
        salesDate: data.purchaseSalesDateNepali,
        orderNo: data.orderNo,
        reportType: data.reportType,
        referenceNumber: data.referenceNumber,
        vatTypeEnum: data.vatTypeEnum,
        billToName: data.billToName,
        remarks: data.remarks,
        totalBillAmount: data.totalBillAmount,
        discountAmt: 0.0,
        nonTaxableAmount: 0.0,
        taxableAmount: 0.0,
        vatAmount: 0.0,
        // totalBillAmount: 0.0,
        extraExpenseList: [],
        extraExpensesSalesList: []
      }
      this.$router.push({name: 'sales Detail Report', params: {salesHeaderObj: PIHdata}})
    },
    showReasonDialog(data) {
      this.inventoryHeaderId = data.id
      this.ecommerceStatusData = data.ecommerceStatus
      if (data.ecommerceStatus === 'Hold' || data.ecommerceStatus === 'Cancelled') {
        this.ecommerceStatusDialog = true
        this.inventoryHeaderId = data.id
        this.ecommerceStatusData = data.ecommerceStatus
      }
      if (data.ecommerceStatus === 'Completed') {
        this.reason = '-'
        this.updateOrderStatus()
      }
    },
    async updateOrderStatus() {
      let data = {
        inventoryHeaderId: this.inventoryHeaderId,
        statusType: this.ecommerceStatusData,
        reason: this.reason
      }
      let resp = await this.$store.dispatch('updateStatusOfdOrder', data)
      if (resp.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: resp.data.message, life: 10000})
        this.ecommerceStatusDialog = false
      }
    },
    getStatusLabel(status) {
      switch (status) {
        case 'Processing':
          return 'Processing'

        case 'Hold':
          return 'Hold'

        case 'Completed':
          return 'Completed'

        case 'Cancel':
          return 'Cancelled'

        default:
          return 'NA'
      }
    },
    exportCSV() {
      let data = {
        fromDate: this.fromDate,
        toDate: this.toDate,
        columnList: this.columnList
      }
      axios({
        url: globalKey + '/fileDownload/excelReport/' + this.$store.getters.organisationId + '/' + this.$store.getters.userId + '/' + data.fromDate + '/' + data.toDate + '/salesOrder' + '/' + this.$store.getters.fyId + '/' + data.columnList,
        method: 'get',
        headers: {'Accept': 'application/vnd.ms-excel', 'Authorization': localStorage.token},
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]), {type: response.data.type})
        const link = document.createElement('a')
        const contentDisposition = response.headers['content-disposition']
        let fileName = 'salesOrder.xlsx'
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1]
          }
        }
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      })
    },
    exportToPdf(SOHeaderId) {
      axios({
        url: globalKey + '/fileDownload/printSalesBill/' + SOHeaderId + '/salesOrder' + '/' + this.$store.getters.organisationId + '/' + this.$store.getters.userId,
        method: 'get',
        headers: {'Accept': 'application/pdf', 'Authorization': localStorage.token},
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]), {type: response.data.type})
        const link = document.createElement('a')
        const contentDisposition = response.headers['Content-Disposition']
        let fileName = 'salesOrder.pdf'
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1]
          }
        }
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      })
    },
    expexportToPdfOrderortToPdf() {
      if (this.selectedSalesOrderId !== null) {
        this.selectedSalesOrderId.forEach(salesOrderId => this.idsForOrderPrint.push(salesOrderId.id))
      }
      if (this.idsForOrderPrint.length <= 0) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please select atleast one order!', life: 10000})
        return
      }
      if (this.idsForOrderPrint.length > 5) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Sorry Cannot more then 5 order!', life: 10000})
        return
      }
      axios({
        url: globalKey + '/fileDownload/printOrderForKritiCraft/' + this.$store.getters.organisationId + '/' +
          this.$store.getters.userId + '/' + this.idsForOrderPrint,
        method: 'get',
        headers: {'Accept': 'application/pdf', 'Authorization': localStorage.token},
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]), {type: response.data.type})
        const link = document.createElement('a')
        const contentDisposition = response.headers['Content-Disposition']
        let fileName = 'Order No' + this.idsForOrderPrint + '.pdf'
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1]
          }
        }
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      })
      this.idsForOrderPrint = []
      this.selectedSalesOrderId = null
    },
    columnNames() {
      for (let i = 0; i < this.$refs.dt.columns.length; i++) {
        this.columnList += this.$refs.dt.columns[i].header + ','
      }
    },
    editSalesOrder(data) {
      this.$router.push({name: 'Sales Order', params: {salesOrder: data}})
    },
    selectedSalesOrder(data) {
      // this.selectedSalesOrderId.push(data.id)
      if (!this.idsForOrderPrint.includes(data)) {
        this.idsForOrderPrint.push(data)
      }
    },
    async deleteReport(value) {
      if (value.trim() === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Delete reason cannot be empty!', life: 10000})
        this.dialogShow = true
        return
      }
      let deleteRe = {
        inventoryOutHeaderId: this.accountId,
        deleteReason: value
      }
      let resp = await this.$store.dispatch('deleteSalesOrder', deleteRe)
      if (resp.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: resp.data.message, life: 10000})
      } else {
        this.$toast.add({severity: 'error', summary: '', detail: resp.data.message, life: 10000})
      }
      this.dialogShow = false
    },
    cancel(data) {
      this.dialogShow = false
      this.ecommerceStatusDialog = false
      this.reason = ''
    },
    openDialog(id) {
      this.dialogShow = true
      this.accountId = id
    },
    setNepaliDate() {
      if (this.$store.getters.nepaliNewDate !== '') {
        this.fromDate = this.$store.getters.nepaliNewDate
        this.toDate = this.$store.getters.nepaliNewDate
      }
    },
    reset() {
      this.salesOrderCompletedLists = []
      if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
        this.fromDate = this.$store.getters.nepaliNewDate
        this.toDate = this.$store.getters.nepaliNewDate
      } else {
        this.fromDate = new Date().toISOString().slice(0, 10)
        this.toDate = new Date().toISOString().slice(0, 10)
      }
    },
    setEnglishDate() {
      this.fromDate = new Date().toISOString().slice(0, 10)
      this.toDate = new Date().toISOString().slice(0, 10)
    },
    checkEnglish() {
      if (this.$store.state.isEnglishDateEnabled === false || this.$store.state.isEnglishDateEnabled === 'false') {
        this.englishDateEnabled = true
        return
      } else {
        this.englishDateEnabled = false
        return
      }
    },
    nepaliDate() {
      $('#fromDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.fromDate = $('#fromDate').val()
        }
      })
      $('#toDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.toDate = $('#toDate').val()
        }
      })
    }
  },
  components: {
    DatePicker,
    DataTable,
    Column,
    Dialog,
    InputText,
    // Toast,
    InputMask,
    Dropdown,
    Dialogs,
    Checkbox,
    Button
  }
}
</script>
<style scoped src="@../../../static/css/purchase.css">

</style>



// WEBPACK FOOTER //
// salesOrderCompletedReport.vue?2dcfaca8